module.exports = __webpack_public_path__ + "media/images/story/top/title_how_to_use-ea4ef350667cc20daf59b86ba2d57c80.jpg";